module.exports = __webpack_public_path__ + "img/aghk-train-disabled.c26b09fa.svg";